module.exports = __webpack_public_path__ + "img/appdownload-main4@2x.6eb93188.png";